import type { FC } from 'react'
import { useEffect, useState } from 'react'
import { authenticatedSelector } from '@onhandtech/onhand-fe-shared/lib/firebase'
import type { RouteLayoutType } from 'contracts/config/routes'
import { useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import { authInitializedSelector } from 'redux/authentication/selectors'

import { getRoutePath } from '../../router/router.utils'

import AdminLayout from './layouts/admin/admin-layout'
import AuthLayout from './layouts/auth/auth-layout'

const Layout: FC = () => {
  const [layoutType, setLayoutType] = useState<RouteLayoutType>('auth')
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const authenticated = useSelector(authenticatedSelector)
  const authInitialized = useSelector(authInitializedSelector)

  const isAdminPath = pathname.includes('/admin/')

  useEffect(() => {
    setLayoutType(pathname.includes('/auth/') ? 'auth' : 'admin')
  }, [pathname])

  useEffect(() => {
    if (authInitialized && isAdminPath && !authenticated) {
      navigate(getRoutePath('SIGN_IN'))
    }
  }, [authInitialized, authenticated, isAdminPath, navigate])

  // Render nothing until auth resolves or until redirect effect fires — prevents a flash of admin content
  if (!authInitialized || (isAdminPath && !authenticated)) {
    return null
  }

  if (layoutType === 'admin') {
    return <AdminLayout />
  }

  return <AuthLayout />
}

export default Layout
